<script setup lang="ts">
import {ref} from 'vue'
import CardList from './taro/CardList.vue';
import ModalCardDay from './taro/ModalCardDay.vue';
import {
    useCardsStore
} from '../stores/cards';
const cardsStore = useCardsStore()
</script>

<template>
    <div class="rotate_none">

        <button @click="cardsStore.mixCards">Перемещать</button>
        <button @click="rotateAll">Перевернуть все</button>
        <button @click="cardDay">Карта дня</button>
        <CardList :cards="cardsStore.cards"></CardList>
        <ModalCardDay
            :messageDayCard="messageDayCard" 
            :cardOfDay="cardOfDay"
            v-show="isModalVisible"
            @close="closeModal"
        >
        </ModalCardDay>
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

interface MessageStrings {
    string: string,
    type: string
}

export default defineComponent({
    data() {
        return {    
            messageDayCard: [] as string[] | undefined[],        
            cardOfDay: '',
            isModalVisible: false,
            shufle_interval: 0 as any,
        }
    },
    computed: {
        cardsStore: () => useCardsStore()
    }, 
    async mounted() {
        const response = await fetch('/api/getCards')
        const data = await response.json()
        this.cardsStore.cards = data.cards_paths.map((card: string) => {
            return {
                path: card,
                classes: ''
            }
        })
    },
    
    methods: {
        hoverOver(event: number) {
            console.log(event)
            
        },

        async mixCards() {
            this.cardsStore.mixCards()
            
        },
        closeModal() {
            this.isModalVisible = false;
        },
        async cardDay() {
            let cardOfDay = this.cardsStore.cardDay as {path: string, index: number}
            this.startShuffle(cardOfDay.path)
            const response = await fetch('/api/cardOfDay', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({cardName: cardOfDay.path})
                })
            const data = await response.json()
            console.log(data.message)
            let arr = data.message.map((str: string) => {
                let type = 'plain'
                if(str.includes('*')) type = 'h2'
                if(str.includes('**')) type = 'h1'
                
                if(!str) type = 'br'
                return {
                    string: str.replaceAll('*', ''),
                    type: type

                }
            })
            this.messageDayCard = arr
            this.cardOfDay = cardOfDay.path
            this.stopShuffle(cardOfDay.path)
        },

        startShuffle(path: string) {
            this.$el.classList.remove('rotate_all')
            this.$el.classList.add('rotate_none')
            this.shufle_interval = setInterval(() => {
                this.cardsStore.mixCards()
            }, 300)
            
        },
        stopShuffle(path: string) {
            
            setTimeout(() => {
                clearInterval(this.shufle_interval)
                this.cardsStore.selectedCard(path)
            }, 500)

            setTimeout(() => {
                this.isModalVisible = true
            }, 6500)
        },
        rotateAll() {
            this.cardsStore.trimClasses()
            //this.cards = trimClasses(this.cards)
            this.$el.classList.toggle('rotate_all')
            this.$el.classList.toggle('rotate_none')
            // if(this.$el.classList.contains('rotate_all')){
            //     this.$el.classList.remove('rotate_all')
            //     this.$el.classList.add('rotate_none')
            // } else {
            //     this.$el.classList.remove('rotate_none')
            //     this.$el.classList.add('rotate_all')
            // }
        }
    },
    name: 'TaroWrap',
    components: {
        CardList
    }
})
</script>

<style scoped></style>
/*
Карта "Кавалер Рушил" (Knight of Swords) в таро - это карта, которая часто связана с мыслительством, идеями,
коммуникацией и решением проблем. Это также карта действия, движения и перемен.

В таро, Кавалер Рушил часто символизирует следующее:

1. **Активность и действие**: Кавалер Рушил часто указывает на необходимость действовать, принимать решения и принимать
меры для достижения цели.
2. **Идеи и мысли**: Это карта мысли, идеи и инноваций. Она может указывать на то, что вы должны подумать о новой идее
или решить проблему.
3. **Кommunikация и общение**: Кавалер Рушил часто связан с коммуникацией, письмом, речью и выражением своих мыслей и
чувств.
4. **Решение проблем**: Это карта решения проблем, особенно тех, которые требуют логического мышления и анализа.

В зависимости от контекста и расположения карт в колоде, Кавалер Рушил может иметь разные значения. Например:

* Если он появляется в верхней части колоды, он может указывать на начало нового проекта или идеи.
* Если он появляется в нижней части колоды, он может указывать на необходимость решить проблему или разобраться в
сложной ситуации.
* Если он появляется рядом с картой "Дама Рушил", он может указывать на необходимость коммуникативного взаимодействия
или диалога.

В целом, Кавалер Рушил в таро - это карта, которая говорит о необходимости действовать, решать проблемы и выражать свои
мысли и чувства.
*/
